/* eslint-disable */
/* Prop type "array" is forbidden */
/* Por ser um componente o tipo array genérico é esperado */

import PropTypes from 'prop-types';
import { Typography } from "@material-ui/core";
import { LoadingButton } from "../../Loading";
import EnhancedTable from "../EnhancedTable";
import CrudDialog from "../CrudDialog";
import BotaoContainer from "../BotaoContainer/styles";
import { ACTIONS } from "../../../utils/financialHelper";

const CrudTablePage = ({
  isLoading,
  funcionalidade,
  rows,
  setRows,
  headCells,
  handleView,
  handleEdit,
  handleDelete,
  handleClone,
  filterValue,
  setFilterValue,
  dadoFoiModificado,
  setDadoFoiModificado,
  open,
  title,
  buttonLabel,
  handleClose,
  handleSubmit,
  action,
  children,
  handleOpen,
  textoBotaoInicial = 'Adicionar',
  onClickBotaoInicial = handleOpen,
  dialogAdicional = <></>
}) => (
  <>
    {
      isLoading ? (
        <Typography variant="h6">
          Carregando {funcionalidade} ...
          <LoadingButton />
        </Typography>
      ) : (
        <>
          <EnhancedTable
            title={funcionalidade}
            rows={rows}
            setRows={setRows}
            headCells={headCells}
            handleView={handleView}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleClone={handleClone}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            dadoFoiModificado={dadoFoiModificado}
            setDadoFoiModificado={setDadoFoiModificado}
          />

          <CrudDialog
            open={open}
            title={title}
            buttonLabel={buttonLabel}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            isDelete={action === ACTIONS.DELETE}
          >
            {children}
          </CrudDialog>

          {dialogAdicional}

          <BotaoContainer>
            <button type="button" onClick={onClickBotaoInicial}>
              {textoBotaoInicial}
            </button>
          </BotaoContainer>
        </>
      )
    }
  </>
);

CrudTablePage.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  funcionalidade: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  setRows: PropTypes.func.isRequired,
  headCells: PropTypes.array.isRequired,
  handleView: PropTypes.func,
  handleEdit: PropTypes.func,
  handleDelete: PropTypes.func,
  handleClone: PropTypes.func,
  filterValue: PropTypes.string.isRequired,
  setFilterValue: PropTypes.func.isRequired,
  dadoFoiModificado: PropTypes.bool.isRequired,
  setDadoFoiModificado: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  handleOpen: PropTypes.func.isRequired,
  dialogAdicional: PropTypes.element,
};

CrudTablePage.defaultProps = {
  handleView: null,
  handleEdit: null,
  handleDelete: null,
  handleClone: null,
};

export default CrudTablePage;